import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const Spot = () => {
    const amenities = [
        "Fully Fenced", 
        "Agility A-Frame & Tunnel", 
        "Fresh Water Station", 
        "Sensory Garden", 
        "Human Seating Area (Shaded)", 
        "Biodegradable Poop Bags",
        "Secure Gate Entry", 
        "Off-road Parking",
        "Dedicated Pet Memorial Wall"
    ];

    return (
        <div className="py-12 container mx-auto px-6">
            <h1 className="font-display text-4xl md:text-5xl text-emerald-900 text-center mb-4">The Spot</h1>
            <p className="text-center text-gray-600 max-w-2xl mx-auto mb-16">
                Designed with your dog's happiness in mind. Explore what makes our park special.
            </p>

            <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                <div className="bg-white p-8 rounded-2xl shadow-sm">
                    <h3 className="font-display text-2xl text-gray-800 mb-6">Park Amenities</h3>
                    <ul className="space-y-4">
                        {amenities.map((item, index) => (
                            <li key={index} className="flex items-center space-x-3 text-gray-700">
                                <CheckCircle className="text-emerald-500" size={20} />
                                <span>{item}</span>
                            </li>
                        ))}
                    </ul>
                    <div className="mt-8">
                         <Link to="/app" className="bg-emerald-600 text-white px-6 py-3 rounded-full font-bold hover:bg-emerald-700 transition">
                            Book a Visit
                         </Link>
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <div className="aspect-square bg-gray-300 rounded-xl overflow-hidden relative group">
                        <div className="absolute inset-0 flex items-center justify-center text-gray-500 font-bold bg-gray-200">Agility Course</div>
                        {/* Replace with <img src="URL" className="object-cover w-full h-full" /> */}
                    </div>
                    <div className="aspect-square bg-gray-300 rounded-xl overflow-hidden relative group mt-8">
                        <div className="absolute inset-0 flex items-center justify-center text-gray-500 font-bold bg-gray-200">Water Station</div>
                    </div>
                    <div className="aspect-square bg-gray-300 rounded-xl overflow-hidden relative group">
                        <div className="absolute inset-0 flex items-center justify-center text-gray-500 font-bold bg-gray-200">The View</div>
                    </div>
                    <div className="aspect-square bg-gray-300 rounded-xl overflow-hidden relative group mt-8">
                        <div className="absolute inset-0 flex items-center justify-center text-gray-500 font-bold bg-gray-200">Seating</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Spot;